module.exports = __webpack_public_path__ + "static/media/Alvvays - Archie, Marry Me (Official Video).e4998b40.mp3";